import { Grid, Divider } from '@material-ui/core'
import styled from 'styled-components'
import { ContainerSombra } from '../../../../components/ContainerSombra'
import { Tipografia } from '../../../../components/Tipografia'
import { customTheme } from '../../../../styles/customTheme'

export const recuperacaoBoxStyles = {
  Box: styled(ContainerSombra).attrs((props: { width: string; maxwidth: string }) => props)`
    margin: auto;
    padding: 16px;
    margin-top: 24px;
    margin-bottom: 24px;
    width: ${(props) => props.width};
    max-width: ${(props) => props.maxwidth};
  `,
  GridItem: styled(Grid)`
    display: flex;
    align-items: center;
  `,
  Image: styled.img`
    width: 80px;
    margin-right: 16px;
  `,
  TipografiaMes: styled(Tipografia)`
    display: block;
    height: 80px;
    width: 80px;
    line-height: 80px;
    margin-left: 16px;
    -moz-border-radius: 60px;
    border-radius: 60px;
    background-color: ${customTheme.colors.grey01};
    text-align: center;
  `,
  Divider: styled(Divider)`
    height: 80px;
  `
}
